<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <div class="row" v-for="report in reports">
      <div class="col-12 px-0" v-if="report.EnabledForAdmin == true && report.Settings && report.Settings.Diagrams.length > 0">
        <div class="card">
          <div class="card-header d-flex align-items-center" style="display:block !important">
            <h1 class="mb-0 pull-left">{{report.extendedName}}</h1>
            <!--<span class="ml-2 pull-left">Some title</span>-->

            <div class="hstack gap-2 ms-auto pull-right">
              <div class="dropdown">
                <a href="#" class="text-body dropdown-toggle" data-toggle="dropdown">
                  <i class="ph-github-logo"></i>
                </a>
                <div class="dropdown-menu" style="position: absolute; inset: 0px 0px auto auto; margin: 0px; transform: translate(0px, 22px);" data-popper-placement="bottom-end">
                  <a class="dropdown-item" v-bind:href="$store.getTodoUrl() + '?reportid=' + report.Id" target="_blank">{{$t('view')}}</a>
                  <a href="#" class="dropdown-item" @click="reloadReports">Reload</a>
                </div>
              </div>
            </div>
          </div>
          
          <div class="card-body" v-if="report.Settings && report.Settings.Diagrams.length > 0">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12 col-md-4 px-0" style="float:left; margin-right:5px;" v-if="report.Settings" v-for="diagram in report.Settings.Diagrams">
                  <report-diagram-view v-bind:reportid="report.Id" v-bind:name="diagram.Name"></report-diagram-view>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  
  export default {
    name: "admin-report-diagram-view",
    components: {

    },
    props: {

    },
    data() {
      return {
        reports :[]
      };
    },
    methods: {
      getId() {
        return this._uid;
      },
      reloadReports() {
        var tmp = JSON.stringify(this.reports);
        this.reports = [];
        Vue.set(this, "reports", this.reports)
        this.$forceUpdate();
        var thisContext = this;
        setTimeout(function () {
          Vue.set(thisContext, "reports", JSON.parse(tmp))
          thisContext.$forceUpdate();
        }, 500)
      },
      async getReport() {
        try {

          this.$http.get('/api/Reports/v1/Site/Schedules').then(async response => {
            this.reports = response.data;
          });

        } catch (err) {
          alert('some error:' + err)
        }
      },
    },
    watch: {
    },
    mounted() {
      this.getReport();
    }
  };
</script>

<style scoped>
  @media screen and (min-width:768px) {
    .col-md-4 {
      max-width: 30%;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/report/admin-report-diagram-view.vue